import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import { GetProductById, SECRET_KEY, FetchService, addToFavorites, GoToCheckout } from "../Functions"; // Adjust import as needed
import Navbar from '../components/Navbar';
import ProductSkeleton from "../components/ProductSkeleton";
import VoucherCard from "../components/VoucherCard";
import netflix_logo from '../assets/Group 22348.png'
import binance_logo from '../assets/Group 22349.png'
import bolt_logo from '../assets/Group 22350.png'
import playstation_logo from '../assets/Group 22347.png'
import Footer from "../components/Footer";
import VoucherSkeleton from "../components/VoucherSkeleton";
import { Col, InputNumber, Row, Slider, Space } from 'antd';


export default function SingleProduct() {

  const [searchParams] = useSearchParams();
  const [singleProduct, setSingleProduct] = useState(null);
  const [simularProducts, setSimularProducts] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [loadingSimilar, setLoadingSimilar] = useState(false);

  const [isFavorite, setIsFavorite] = useState(false);

  const [amountRangeSelector, setAmountRangeSelector] = useState(false)
  const [amountValue, setAmountValue] = useState(0);

  const handleClick = () => {
    addToFavorites(singleProduct);
    console.log(singleProduct)
    if (isFavorite) {
      setIsFavorite(false)
    } else {
      setIsFavorite(true);
    }

  };

  // Fetch single product
  const fetchData = async () => {
    setLoadingProduct(true);
    const encryptedData = searchParams.get("data");
    if (!encryptedData) return setLoadingProduct(false);

    try {
      // Decrypt the parameters
      const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      // Extract serviceId and productId
      const { serviceId, productId } = decryptedData;

      const data = await GetProductById(serviceId, productId);
      setSingleProduct(data);

      if (data.prices.retail.amount.min || data.prices.retail.amount.min ) {
        setAmountRangeSelector(true)
        setAmountValue(data.prices.retail.amount.min)
      }else{
        setAmountRangeSelector(false)
      }
   

    } catch (error) {
      console.error("Error decrypting parameters or fetching product:", error);
    } finally {
      setLoadingProduct(false);
    }
  };

  // Fetch similar products
  const fetchSimularData = async () => {
    setLoadingSimilar(true);
    const encryptedData = searchParams.get("data");
    if (!encryptedData) return setLoadingSimilar(false);

    try {
      // Decrypt again (to get serviceId)
      const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      const { serviceId } = decryptedData;
      const similarData = await FetchService(serviceId);

      if (similarData.Products && similarData.Products.length > 0) {
        // Shuffle the array and take 10 random products
        const shuffled = similarData.Products.sort(() => 0.5 - Math.random());
        const randomProducts = shuffled.slice(0, 10);

        setSimularProducts(randomProducts);
      } else {
        setSimularProducts([]);
      }
    } catch (error) {
      console.error("Error decrypting parameters or fetching similar products:", error);
    } finally {
      setLoadingSimilar(false);
    }
  };



  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
    fetchSimularData();

  }, [searchParams]);



  useEffect(() => {
    if (!singleProduct) return;
  
    const favorites = JSON.parse(sessionStorage.getItem("gbx_data"))?.user?.favorites || [];
  
    const isInFavorites = favorites.some((fav) => fav.id === singleProduct.id);
    setIsFavorite(isInFavorites);
  }, [singleProduct]);
  



  const onChange = newValue => {
    setAmountValue(newValue);
  };


  return (
    <>
      <Navbar />
      <div data-aos="fade-down" className="container" style={{ marginTop: '100px' }} >
        <div className="row" >

          <div className="col-lg-8  col-md-7 " >

            <div className="row" >

              {loadingProduct ? (
                <ProductSkeleton />
              ) : (
                <div className="row">

                  <div className="col-lg-5 col-md-6">
                    <img
                      className="br_10 w-100"
                      src={singleProduct?.image}
                      alt={singleProduct?.name}
                    />
                  </div>

                  {/* Product Details */}
                  <div className="col-lg-7 col-md-10  py-4">

                    <h5 className="button_sm bg_purple_light d-flex flex-column justify-content-center align-items-center primary_purple bold p-0 mb-2">
                      {singleProduct?.service?.name || "Unknown Voucher"}
                    </h5>

                    <h3 className="text-dark bold">{singleProduct?.name || "Unknown Voucher"}</h3>

                    <h4 className="text-dark mt-2">{singleProduct?.description || "Unknown Voucher"}</h4>

                    <h4 className="text-dark mt-2">
                      <span className="bold">Validity: </span>
                      {singleProduct?.validity?.quantity} {singleProduct?.validity?.unit}
                    </h4>

                    <h3 className='bold mt-2'>
                      {typeof singleProduct?.prices?.retail?.amount === "object" && singleProduct?.prices?.retail?.amount?.min !== undefined
                        ? `$${singleProduct?.prices?.retail?.amount?.min} - $${singleProduct?.prices?.retail?.amount?.max}`
                        : `$${singleProduct?.prices?.retail?.amount || 'N/A'}`}
                    </h3>

                    {amountRangeSelector ?
                      <div className='mt-2' >
                        <p className='text-dark'>Select price :</p>

                        <div className='d-flex flex-row align-items-center' >
                          <Col span={12}>
                            <Slider
                              min={singleProduct.prices.retail.amount.min}
                              max={singleProduct.prices.retail.amount.max}
                              onChange={onChange}
                              value={amountValue}
                            />
                          </Col>
                          <p className="bold text-dark">${amountValue}</p>
                        </div>


                      </div>


                      : ""
                    }

                    <div className="d-flex w-100 gap-3 flex-column mt-4">
                      <button className=" buy_button_large bold" 
                      onClick={() => GoToCheckout(singleProduct, amountRangeSelector ? amountValue  : null)}

                      >Buy</button>

                      <button
                        className={`favourites_button bold bg_purple ${isFavorite ? "favorite" : ""}`}
                        onClick={handleClick}>

                        {isFavorite ? "Remove from Favorites" : "Add To Favorites"}
                        <p className="text-dark">❤︎</p>
                      </button>

                    </div>

                  </div>
                </div>
              )}


              <section className='py-12' >
     
                <h2>Most Popular Vouchers</h2>


                <div className="row" >
                  <div className="col-lg-6 col-md-12 pt-3" >

                    <div className='grid-item grid-item-1'>
                      <img src={netflix_logo} className='mt-5' />
                      <div>
                        <h3>Netflix</h3>
                        <p>Stream movies, shows, and originals <br></br>
                          with a Netflix voucher. Redeem for <br></br> entertainment anytime, anywhere.</p>

                      </div>
                      <button className="home_button_white" onClick={() => window.location.href = "/products?search=Netflix"} >View Vouchers</button>
                    </div>

                  </div>

                  <div className="col-lg-6 col-md-12 pt-3" >
                    <div className='grid-item grid-item-2' >
                      <img src={binance_logo} className='mt-5' />
                      <div>
                        <h3>Binance</h3>
                        <p>Boost your crypto journey with Binance <br></br>
                          vouchers. Use them to trade, invest, <br></br> or explore services on a top exchange.</p>

                      </div>
                      <button className="home_button_white" onClick={() => window.location.href = "/products?search=Binance"}>View Vouchers</button>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 pt-3 " >

                    <div className='grid-item grid-item-3' >
                      <img src={bolt_logo} className='mt-5' />
                      <div>
                        <h3>Bolt</h3>
                        <p>Travel smarter with Bolt gift vouchers. Use them <br></br>
                          to pay for convenient, fast, and affordable rides <br></br>
                          or deliveries in cities around the world.</p>

                      </div>
                      <button className="home_button_white" onClick={() => window.location.href = "/products?search=Bolt"} >View Vouchers</button>
                    </div>
                  </div>

                </div>



              </section>

            </div>


          </div>


          {/* Simular Vouchers */}
          <div className="col-lg-4 col-md-5" style={{ borderLeft: '1px solid #EFEBFF' }}>
            <h4 className="bold mb-2">Similar Vouchers</h4>

            {loadingSimilar ? (
              <>
              {[...Array(6)].map((_, i) => (
                <VoucherSkeleton key={i} />
              ))}
            </>
            
            ) : (
              simularProducts && simularProducts.length > 0 ? (
                simularProducts.map((product, index) => (

                  <VoucherCard key={index} product={product} />

                ))
              ) : (
                <div>No similar products found.</div>
              )
            )}
          </div>


        </div>
      </div>



      <Footer />
    </>
  )


}
